module.exports = __webpack_public_path__ + "img/取消授权.f542aa4f.svg";